<div id="loadingIndicator" *ngIf="Loading">
  <div class="progress">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75"
      aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</div>

<header class="mb-5">
  <nav class="px-3 py-3 bg-dark text-white">
    <div class="container-fluid">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">

        <a routerLink="/" class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-white text-decoration-none">
          <img class="bi me-2" src="../../../assets/logo.svg" alt="Mercedes logo" width="48">
          <h5 class="mb-0 me-2">LDS HUB</h5>
          <small [ngClass]="Production ? 'text-danger' : 'text-info'">{{ Production ?'production' : 'test'}}</small>
        </a>

        <div class="d-flex align-items-center my-2 my-lg-0 me-lg-auto text-danger">
          System contains sensitive information!
        </div>

        <ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
          <li class="btn-group me-2">
            <button type="button" class="btn btn-light" routerLink="dial" routerLinkActive="text-white bg-primary border-primary"
              [routerLinkActiveOptions]="{exact: true}">
              Central HUB
          </button>
          </li>
          <li class="btn-group me-2">
            <button type="button" class="btn btn-light" routerLink="publicgateway" routerLinkActive="text-white bg-primary border-primary"
              [routerLinkActiveOptions]="{exact: true}">
              Public
          </button>
          </li>
          <li class="btn-group me-2">
            <button type="button" class="btn btn-light" routerLink="admin/gateway" routerLinkActive="text-white bg-primary border-primary"
              [routerLinkActiveOptions]="{exact: true}" [disabled]="!isAdmin()">
              Applications
          </button>
          </li>
          <li class="btn-group me-2">
            <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
            [disabled]="!isAdmin()">
              Admin panel
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="/admin/apps"
                  [routerLinkActiveOptions]="{exact: true}">Application List</a>
              </li>
              <li><a class="dropdown-item" routerLinkActive="active" routerLink="admin/apps/add"
                  [routerLinkActiveOptions]="{exact: true}">Add Application</a></li>
            </ul>
          </li>
          <li *ngIf="User;else noUser">
            <div class="dropdown ms-3">
              <button class="btn btn-primary" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                aria-expanded="false">
                <i class="bi bi-person-fill me-2"></i>
                {{ User.Username }}
              </button>
              <div class="dropdown-menu">
                <div class="p-3 text-muted text-nowrap">
                  <b>{{ User.Email }}</b> <br>
                  <b>{{ User.Role }}</b> <br>
                  <hr class="dropdown-divider">
                  <button (click)="logout()" class="btn btn-secondary">Sign out</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<ng-template #noUser>
  <button routerLink="/login" class="btn btn-primary ms-3">Login</button>
</ng-template>